/**
 * What each content type is called, and what it is for.
 *
 * The names lived inside one component that happened to need them, so the
 * screen where you actually edit a content type showed its database key —
 * "ourtrustedclients" — as a heading. One definition, read by everything that
 * has to name these.
 */
export const LIBRARY_LABELS = {
  blogs: 'Blog posts',
  news: 'News',
  projects: 'Projects',
  services: 'Services',
  aboutus: 'About us',
  ourstory: 'Our story',
  summary: 'Summary',
  ourteam: 'Our team',
  ourpartners: 'Partners',
  ourtrustedclients: 'Trusted clients',
  recommendations: 'Recommendations',
  faq: 'Questions and answers',
  pricing: 'Pricing',
  locations: 'Locations',
  openinghours: 'Opening hours',
  certifications: 'Certifications',
  downloads: 'Downloads',
  gallery: 'Gallery',
  videos: 'Videos',
  press: 'Press',
  events: 'Events',
  jobs: 'Jobs',
  process: 'How it works',
  stats: 'Numbers',
  contact: 'Contact details',
  policies: 'Policies',
  // Not a content-library collection — the shop's own products. It is named
  // here because a page section binds to it exactly as it binds to the rest.
  products: 'Shop products',
};

/** One line saying what this type is for, shown under its name. */
export const LIBRARY_HINTS = {
  blogs: 'Write once here; every page showing your blog picks it up.',
  news: 'Announcements, shown wherever you put a news section.',
  projects: 'Work you have done, for a portfolio or case study page.',
  services: 'What you offer, reusable across every page that lists it.',
  ourteam: 'The people, with their roles and photographs.',
  ourpartners: 'Companies you work with.',
  ourtrustedclients: 'Logos and names you are allowed to show.',
  recommendations: 'What customers said about you.',
  faq: 'Questions you answer often, in one place.',
  events: 'What is coming up, with dates and places.',
  jobs: 'Roles you are hiring for.',
  products: 'Items from your shop. Prices and pictures come from the product itself.',
};

/** The display name for a content type, falling back to the key itself. */
export const libraryLabel = (key) => LIBRARY_LABELS[key]
  || String(key || '').replace(/[-_]/g, ' ').replace(/^./, (c) => c.toUpperCase());

/** The line under the name, if this type has one worth saying. */
export const libraryHint = (key) => LIBRARY_HINTS[key]
  || 'Fill this in once and every page that shows it stays in step.';

const libraryLabels = { LIBRARY_LABELS, LIBRARY_HINTS, libraryLabel, libraryHint };
export default libraryLabels;
